const isAuthenticated = async  (to, from ,next) =>{
    if(localStorage.getItem('apiKey')) return  next()
    return next('/login')
}



export default isAuthenticated;